import ListDocument from './list-document.container'

export default ListDocument